
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title 
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Jay Dev Jay Venkateshaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Aarti "Jay Dev Jay Venkateshaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: 'Venkatesh Ji Ki Aarti, Venkatesh Ji Ki Aarti - lyrics In English & Hindi, Shri Venkatesh Aarti, Jay Dev Jay Dev jay Venkatesha, Venkatesh Aarti With Lyrics, tirupati balaji aarti'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Shri Venkatesh Aarti, Jay Dev Jay Dev jay Venkatesha, Venkatesh Ji Ki Aarti - lyrics In English & Hindi, Shri Venkatesha Aarti - श्री व्यंकटेश आरती, Venkatesh Aarti With Lyrics, Shri Venkatesh Aarti | श्री व्यंकटेश आरती, Jai Jai Venkatesh, श्री व्यंकटेश आरती With Lyrics, Devotional song, balaji aarti lyrics, tirupati balaji aarti, बालाजी की आरती, सालासर बालाजी की आरती' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/balaji.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/balaji.webp'
          },
          ],
        }
      },
    
      components: {
        },
        data() {
          return {
            title: 'Jay Dev Jay Venkateshaa | Venkatesh Aarti - जय देव जय व्यंकटेशा (व्यंकटेश आरती)',
            langauageMarathi: true
          }
        },
        layout: 'detailsPage-withoutFooter',
    

        jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/balaji"
        },
        "headline": "Jay Dev Jay Venkateshaa - जय देव जय व्यंकटेशा (व्यंकटेश आरती)",
        "name" : "Jay Dev Jay Venkateshaa - Venkatesh Aarti",
        "description": "Explore the full lyrics of Aarti 'Jay Dev Jay Venkateshaa' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/balaji.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
    
        computed: {
    
        },
        methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    
      }
    